var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',{attrs:{"align":"center"}},[_c('span',{staticClass:"headline ml-4"},[_vm._v(_vm._s(_vm.conversationType))]),_c('v-spacer'),_c('refresh-btn')],1)}
var staticRenderFns = []

export { render, staticRenderFns }